import { z } from 'zod/v4';

/**
 * Body of the bulk template-delete endpoint.
 *
 * The legacy route took a bare JSON array (`["id1","id2"]`); this wraps it in a
 * named field for the same reasons as the sibling
 * `BulkDeleteQuestionnairesBodySchema` — self-describing in the generated
 * OpenAPI reference, useful validation paths (`body/templateIds/0` rather than
 * `body/0`), and room for further fields without a breaking change.
 *
 * Constraints map 1:1 to the legacy `bulkDelete` JSON Schema shared by both the
 * tenant and admin template routes: `minItems: 1` → `.min(1)`,
 * `items.minLength: 1` → `z.string().min(1)`. Deliberately **uncapped**, as the
 * legacy route was — a `.max()` would newly reject payloads that work today.
 *
 * Duplicates are deliberately NOT rejected here: the service compares the row
 * count it finds against `templateIds.length`, so `["a","a"]` resolves to a
 * single row and fails with `questionnaire_template_not_found`, exactly as the
 * legacy route did.
 */
export const BulkDeleteQuestionnaireTemplatesBodySchema = z.object({
  templateIds: z.array(z.string().min(1)).min(1),
});

export type BulkDeleteQuestionnaireTemplatesBody = z.infer<
  typeof BulkDeleteQuestionnaireTemplatesBodySchema
>;
